import { StatusChip } from "./StatusChip";
import { ToolTip } from "./Tooltip";
import React, { useState } from "react";
import { ParticipantFileStatusCode, TrainingDocumentStatusCode } from "../../types/components";
import { useTranslation } from "react-i18next";
import { isStatusNotApproved } from "../../utils/status";

interface FileStatusProps {
  code: ParticipantFileStatusCode | TrainingDocumentStatusCode;
  comment?: string;
}

const LABELS: Record<ParticipantFileStatusCode | TrainingDocumentStatusCode, string> = {
  approved: "Approved",
  pending_approval: "Pending",
  not_approved: "Not Approved",
  not_uploaded: "Missing",
  waiting_for_approval: "Pending",
  rejected: "Rejected",
};

const TYPES: Record<
  ParticipantFileStatusCode | TrainingDocumentStatusCode,
  "pending" | "approved" | "missing" | "denied"
> = {
  approved: "approved",
  pending_approval: "pending",
  not_approved: "denied",
  not_uploaded: "missing",
  waiting_for_approval: "pending",
  rejected: "denied",
};

export const FileStatus: React.FC<FileStatusProps> = ({ code, comment }) => {
  const [showTooltip, setShowTooltip] = useState(false);
  const { t } = useTranslation();

  const onMouseEnter = () => {
    if (!isStatusNotApproved(code)) {
      return;
    }

    setShowTooltip(true);
  };

  const onMouseLeave = () => setShowTooltip(false);

  return (
    <div className="relative w-fit" onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave}>
      <StatusChip label={t(LABELS[code])} type={TYPES[code]} className="w-fit" />

      {comment && showTooltip ? <ToolTip text={comment} type="nav" position="top" /> : null}
    </div>
  );
};
